import React from "react";
import styled from "styled-components";

const Container = styled.input`
  border: 0;
  border-radius: 10px;
  border: 1px solid #e6e6e6;
  min-height: 38px;
  font-size: 12px;
  padding: 0px 15px;
  box-sizing: border-box;
  width: 100%;
  outline: none;
  opacity: 0.85;
`;

const Input = ({
  placeholder,
  required = true,
  value = "",
  onChange = () => null,
  type = "text",
  readOnly = false,
  className,
  disabled = false,
  style = {},
}) => (
  <Container
    style={style}
    className={className}
    placeholder={placeholder}
    required={required}
    value={value}
    onChange={onChange}
    type={type}
    readOnly={readOnly}
    disabled={disabled}
    autoComplete={"off"}
  />
);

export default Input;
